import React from "react"
import PropTypes from "prop-types"
import { jsx } from "@emotion/react"
import ComplexTableBlock from "components/blocks/ComplexTableBlock.jsx"
import ArticleBlock from "components/blocks/ArticleBlock"
import HighlightCardsBlock from "components/blocks/HighlightCardsBlock"
import EmbedBlock from "components/blocks/EmbedBlock"
import FeatureBlock from "components/blocks/FeatureBlock"
import FlexibleContent from "components/blocks/FlexibleContentBlock"
import IllustratedFeaturesBlock from "components/blocks/IllustratedFeaturesBlock"
import LeadershipGrid from "components/blocks/LeadershipGrid"
import LegalBlock from "components/blocks/LegalBlock"
import SignatureTextBlock from "components/blocks/SignatureTextBlock"
import SimpleTextBlock from "components/blocks/SimpleTextBlock"
import TableBlock from "components/blocks/TableBlock"
import VideoBlock from "components/blocks/VideoBlock"

const blockTypeMap = {
  ComplexTableBlock,
  ArticleBlock,
  HighlightCardsBlock,
  EmbedBlock,
  FeatureBlock,
  FlexibleContent,
  IllustratedFeaturesBlock,
  LeadershipGrid,
  LegalBlock,
  SignatureTextBlock,
  SimpleTextBlock,
  TableBlock,
  VideoBlock,
}

const ContentBlock = ({ type, content, context }) => {
  const component = blockTypeMap[`${type[0].toUpperCase()}${type.slice(1)}`]
  if (component) {
    return jsx(component, { ...content, context, id: `section-${context.key}` })
  }

  return (
    <div>
      No block defined for <code>{type || typeof type}</code> type.
    </div>
  )
}

export default ContentBlock

ContentBlock.propTypes = {
  type: PropTypes.string.isRequired,
  content: PropTypes.object,
  context: PropTypes.shape({
    index: PropTypes.number.isRequired,
    blockCount: PropTypes.number.isRequired,
    key: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    lastType: PropTypes.string,
    nextSectionId: PropTypes.string,
    nthConsecutiveOfType: PropTypes.number.isRequired,
  }).isRequired,
}
